import {NgModule} from "@angular/core";
import {DatePipe} from "./custom-date.pipe";

/**
 * Module pour l'import de DatePipe dans de multiples modules
 *
 * @author Laurent Convert
 * @date 06/03/2025
 */
@NgModule({
	imports: [],
	exports: [DatePipe],
	declarations: [DatePipe],
})
export class DatePipeModule {
}